import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

import { ApiService } from '../api/api.service';

import * as _ from 'lodash';
import { INewWizardContact } from '../../models';
import { IContactSchema } from 'common-lib';

@Injectable({
    providedIn: 'root'
})
export class WizardContactService {
    constructor(private apiService: ApiService) {}

    public addNewContact(contact: INewWizardContact) {
        const name = contact.name && contact.name.trim();
        if (!name || name === '') {
            return throwError('Please add a name for your new contact.');
        }

        if (!contact.email) {
            return throwError('Please make sure you use a valid email address.');
        }

        const newContact = {
            name: contact.name,
            email: [contact.email],
            defaultEmail: contact.email
        };

        return this.postContact(newContact);
    }

    private postContact(contact: { name: string; email: string[]; defaultEmail: string }) {
        return this.apiService.post('contact', contact);
    }

    public getContact(contactEmail: string, options = { includeTeams: 'true' }): Observable<IContactSchema[]> {
        return this.apiService.get('contact', { params: { search: contactEmail, includeTeams: options.includeTeams } });
    }
}
